// @figma file=pkCGby54zXzTsccXvHqzO6 node=tbd name="HoverCard" set="mytaible-shadcn-studio" verified=tbd

import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import * as React from 'react';
import { cn } from '../../lib/utils';

// ─── HoverCard (root) ─────────────────────────────────────────────────────────

export interface HoverCardProps
  extends React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Root> {}

const HoverCard = HoverCardPrimitive.Root;
HoverCard.displayName = 'HoverCard';

// ─── HoverCardTrigger ─────────────────────────────────────────────────────────

export interface HoverCardTriggerProps
  extends React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Trigger> {}

const HoverCardTrigger = React.forwardRef<
  React.ComponentRef<typeof HoverCardPrimitive.Trigger>,
  HoverCardTriggerProps
>(({ className, ...props }, ref) => (
  <HoverCardPrimitive.Trigger ref={ref} className={cn(className)} {...props} />
));
HoverCardTrigger.displayName = 'HoverCardTrigger';

// ─── HoverCardContent ─────────────────────────────────────────────────────────

export interface HoverCardContentProps
  extends React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content> {}

const HoverCardContent = React.forwardRef<
  React.ComponentRef<typeof HoverCardPrimitive.Content>,
  HoverCardContentProps
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Portal>
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-64 rounded-[var(--radius)] border border-border bg-background p-4 shadow-md outline-none',
        'data-[state=open]:animate-in data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        'data-[side=bottom]:slide-in-from-top-2',
        'data-[side=left]:slide-in-from-right-2',
        'data-[side=right]:slide-in-from-left-2',
        'data-[side=top]:slide-in-from-bottom-2',
        className,
      )}
      {...props}
    />
  </HoverCardPrimitive.Portal>
));
HoverCardContent.displayName = 'HoverCardContent';

// ─── Exports ──────────────────────────────────────────────────────────────────

export { HoverCard, HoverCardContent, HoverCardTrigger };
